<script>
import { merchantComputed } from '@state/helpers'

export default {
  data() {
    return {
      defaultBanner: require('@assets/images/activity_default.png'),
      defaultLogo: require('@assets/images/logo_default.png'),
      windowWidth: 0,
      isDefault: true,
      menus: [
        {
          name: 'booking',
          params: {
            merchantAlias: this.$route.params.merchantAlias,
            productType: 'light'
          },
          active: this.$route.name === 'light' || this.$route.params.productType === 'light',
          text: this.$t(`global.MENU_LIGHT`) /* 點燈服務 */,
          textMobile: this.$t(`global.MENU_MOBILE_LIGHT`) /* 點燈 */,
        },
        {
          name: 'booking',
          params: {
            merchantAlias: this.$route.params.merchantAlias,
            productType: 'treasury'
          },
          active: this.$route.name === 'treasury' || this.$route.params.productType === 'treasury',
          text: this.$t(`global.MENU_TREASURY_SERVICE`) /* 補庫服務 */,
          textMobile: this.$t(`global.MENU_MOBILE_TREASURY_SERVICE`) /* 補庫 */,
        },
        {
          name: 'booking',
          params: {
            merchantAlias: this.$route.params.merchantAlias,
            productType: 'puja'
          },
          active: this.$route.name === 'puja' || this.$route.params.productType === 'puja',
          text: this.$t(`global.MENU_PUJA_SERVICE`) /* 法會預訂 */,
          textMobile: this.$t(`global.MENU_MOBILE_PUJA_SERVICE`) /* 法會 */,
        },
        {
          name: 'booking',
          params: {
            merchantAlias: this.$route.params.merchantAlias,
            productType: 'pudu'
          },
          active: this.$route.name === 'pudu' || this.$route.params.productType === 'pudu',
          text: this.$t(`global.MENU_PUDU_SERVICE`) /* 贊普預訂 */,
          textMobile: this.$t(`global.MENU_MOBILE_PUDU_SERVICE`) /* 贊普 */,
        },
        {
          name: 'booking',
          params: {
            merchantAlias: this.$route.params.merchantAlias,
            productType: 'worshipset'
          },
          active: this.$route.name === 'worshipset' || this.$route.params.productType === 'worshipset',
          text: this.$t(`global.MENU_WORSHIPSET_SERVICE`) /* 斗燈服務 */,
          textMobile: this.$t(`global.MENU_MOBILE_WORSHIPSET_SERVICE`) /* 斗燈 */,
        },
        {
          name: 'booking-summary',
          params: {
            merchantAlias: this.$route.params.merchantAlias,
          },
          active: this.$route.name === 'summary',
          text: this.$t(`global.MENU_SUMMARY_SERVICE`) /* 關於 */,
        }
      ]
    }
  },
  computed: {
    ...merchantComputed,
    isShowPrepaid() {
      return this.currentMerchant.showPrepaid
    },
    isMobile() {
      return this.windowWidth <= 768
    },
  },
  mounted() {
    this.setWindowWidth()
    window.addEventListener('resize', this.setWindowWidth)
  },
  destroyed() {
    window.removeEventListener('resize', this.setWindowWidth)
  },
  methods: {
    setWindowWidth() {
      this.windowWidth = document.body.clientWidth
    },
    menuLink(menu) {
      return {
        name: menu.name,
        params: menu.params,
        query: {
          language: this.$route.query.language
        },
      }
    },
  },
}
</script>
<template>
  <div class="booking-section is-banner">
    <div class="subsection__banner">
      <picture class="booking-banner">
        <BaseImage :src="currentMerchant.image" :error-src="defaultBanner" class-name="is-cover" />
      </picture>
    </div>
    <div class="subsection__menu">
      <div class="subsection__menu-left">
        <router-link :to="{ name: 'home', query: { language: $route.query.language } }">
          <picture class="subsection__avatar">
            <BaseImage :src="currentMerchant.logo" :error-src="defaultLogo" class-name="is-cover" />
          </picture>
          <div class="subsection__name subsection__name_new">{{ currentMerchant.name }}</div>
        </router-link>
      </div>
      <div class="subsection__menu-right">
        <div class="menus is-left">
          <router-link
            v-for="(menu, index) in menus"
            :key="index"
            :to="menuLink(menu)"
            :class="{ 'router-link-exact-active': menu.active }"
            class="button is-menu-style"
          >
            {{ isMobile ? (menu.textMobile || menu.text) : menu.text }}
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
